/* Reels carousel.
   Load strategy is the whole point here: three clips all requesting bytes at
   once made the section feel broken. Each video now starts with NO src and
   preload="none"; the src is attached only when the tile comes within 250px of
   the viewport, and playback only starts when it is actually 45% visible.
   A branded placeholder holds the tile until the first frame paints, so the
   customer never sees a blank black box. */
(function(){
var LOGO='https://cdn.shopify.com/s/files/1/1021/7298/3635/files/logo_a7e23ef1-f7f3-477e-9518-9e831c9987da.webp?v=1785507441';

function el(t,s,h){var e=document.createElement(t);if(s)e.setAttribute('style',s);if(h!==undefined)e.innerHTML=h;return e;}

function arrowBtn(dir){
var b=el('button','position:absolute; top:50%; transform:translateY(-50%); '+(dir<0?'left:6px;':'right:6px;')+' width:38px; height:38px; border-radius:50%; border:2px solid #f4e8c8; background:#0d2340; color:#f4e8c8; cursor:pointer; z-index:8; display:none; align-items:center; justify-content:center; box-shadow:0 3px 12px rgba(0,0,0,0.45); padding:0;','<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="'+(dir<0?'M15 5 8 12l7 7':'M9 5l7 7-7 7')+'"></path></svg>');
b.type='button';
b.setAttribute('aria-label',dir<0?'Previous clip':'Next clip');
return b;
}

function placeholder(){
return el('div','position:absolute; inset:0; z-index:2; background:#0d2340; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:10px; transition:opacity .35s ease;',
'<img src="'+LOGO+'" alt="" style="width:44px; height:44px; object-fit:contain; background:#fff; border-radius:10px; padding:4px; opacity:.9;">'+
'<div style="width:34px; height:34px; border-radius:50%; border:2px solid #f4e8c8; display:flex; align-items:center; justify-content:center;">'+
'<svg viewBox="0 0 24 24" width="15" height="15" fill="#f4e8c8"><path d="M8 5v14l11-7z"></path></svg></div>');
}

function init(){
var row=document.getElementById('cd-reels');
if(!row||row.getAttribute('data-cd-ready'))return;
row.setAttribute('data-cd-ready','1');
row.style.scrollBehavior='smooth';

var shell=el('div','position:relative;');
row.parentNode.insertBefore(shell,row);
shell.appendChild(row);
var prev=arrowBtn(-1), next=arrowBtn(1);
shell.appendChild(prev); shell.appendChild(next);

function sync(){
var over=row.scrollWidth>row.clientWidth+8;
prev.style.display=(over&&row.scrollLeft>4)?'flex':'none';
next.style.display=(over&&row.scrollLeft+row.clientWidth<row.scrollWidth-4)?'flex':'none';
}
function step(d){row.scrollLeft+=d*Math.max(row.clientWidth*0.8,200);setTimeout(sync,360);}
prev.onclick=function(e){e.preventDefault();step(-1);};
next.onclick=function(e){e.preventDefault();step(1);};
row.addEventListener('scroll',sync,{passive:true});
window.addEventListener('resize',sync);
sync(); setTimeout(sync,200); setTimeout(sync,900);

var vids=Array.prototype.slice.call(row.querySelectorAll('video'));

vids.forEach(function(v){
var wrap=v.closest('[data-cd-reel]')||v.parentNode;

/* strip the src so nothing downloads until we ask for it */
var src=v.getAttribute('src')||'';
var srcEls=v.querySelectorAll('source');
if(!src&&srcEls.length)src=srcEls[0].getAttribute('src')||'';
Array.prototype.forEach.call(srcEls,function(s){s.parentNode.removeChild(s);});
v.removeAttribute('src');
v.dataset.cdSrc=src;
v.preload='none';
v.muted=true; v.loop=true; v.playsInline=true;
v.setAttribute('playsinline','');
v.setAttribute('muted','');
v.setAttribute('disableremoteplayback','');
v.removeAttribute('autoplay');
v.removeAttribute('controls');
v.style.width='100%'; v.style.height='100%'; v.style.objectFit='cover';
v.style.position='relative'; v.style.zIndex='1';
try{v.load();}catch(e){}

var ph=placeholder();
wrap.appendChild(ph);

var badge=el('div','position:absolute; bottom:10px; left:10px; z-index:4; background:rgba(13,35,64,0.78); color:#f4e8c8; font-size:11px; font-weight:800; padding:5px 10px; border-radius:999px; pointer-events:none; letter-spacing:0.4px;','TAP FOR SOUND');
wrap.appendChild(badge);

v.addEventListener('loadeddata',function(){ph.style.opacity='0';setTimeout(function(){ph.style.display='none';},380);});

wrap.addEventListener('click',function(){
attach();
v.muted=!v.muted;
badge.innerHTML=v.muted?'TAP FOR SOUND':'SOUND ON';
if(v.paused)v.play().catch(function(){});
});

var attached=false;
function attach(){
if(attached||!v.dataset.cdSrc)return;
attached=true;
v.preload='auto';
v.src=v.dataset.cdSrc;
try{v.load();}catch(e){}
}
v.cdAttach=attach;
});

if('IntersectionObserver' in window){
/* stage 1: get close → start downloading */
var near=new IntersectionObserver(function(en){
en.forEach(function(e){if(e.isIntersecting&&e.target.cdAttach){e.target.cdAttach();near.unobserve(e.target);}});
},{rootMargin:'250px'});
/* stage 2: actually visible → play, out of view → pause */
var seen=new IntersectionObserver(function(en){
en.forEach(function(e){
var v=e.target;
if(e.isIntersecting){if(v.cdAttach)v.cdAttach();v.play().catch(function(){});}
else{v.pause();}
});
},{threshold:0.45});
vids.forEach(function(v){near.observe(v);seen.observe(v);});
}else{
vids.forEach(function(v){if(v.cdAttach)v.cdAttach();v.play().catch(function(){});});
}
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
setTimeout(init,400);
})();
